export const GET_PROGRAM_GROUP = "GET_PROGRAM_GROUP";
export const GET_COURSE_BY_ID = "GET_COURSE_BY_ID";
export const GET_COURSE_TASK_LIST = "GET_COURSE_TASK_LIST";
export const GET_COURSE_TASK_DETAILS = "GET_COURSE_TASK_DETAILS";
export const GENERATE_SIMULATION_TOKEN = "GENERATE_SIMULATION_TOKEN";
export const GET_STUDENT_SPECIFIC_DATA = "GET_STUDENT_SPECIFIC_DATA";
